var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8601FF62-8348-4BEE-8774-737DE61FD236") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.0_ShomreyHaderech_ReportingDetails_Crop",
    transform: "translate(-750.000000, -169.000000)",
    stroke: "#293172",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(751.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.14285714,13.786016 C3.04569336,15.5916579 4.509941,17.0635119 6.32062889,17.9852813 C8.11835128,18.8983945 10.1680099,19.2067417 12.1588275,18.8635589 C14.1558344,18.5161537 15.9854103,17.5384364 17.3738391,16.0767163 C18.7750733,14.6011675 19.6672917,12.7239545 19.9221198,10.715211 C20.1808962,8.70186493 19.7910776,6.65906702 18.8080473,4.87762006 C17.834301,3.11000175 16.3126957,1.69833926 14.4670063,0.850421264 C12.6333754,0.0103148712 10.5727682,-0.215022472 8.5978613,0.20860295 C6.62369075,0.631907463 5.00487089,1.59463493 3.66777051,3.11684219 C3.50556839,3.28574174 2.88237076,3.9676737 2.36588506,4.99690537",
    id: "Path",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinejoin: "round",
    points: "6 6.29411765 1.18035985 7 0 3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-8",
    points: "10 5 10 10.5 14 14"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.af32dfd811329f08f1ec9e419b321a45.svg";
export { ForwardRef as ReactComponent };